import React from "react";
import {ImageObservable} from "../../../stores/observables/imageObservable";
import EditField from "../../molecules/editField/editField";
import {Container, Row} from "reactstrap";
import {observer} from "mobx-react-lite";
import ImagePreview from "../imagePreview/imagePreview";
import FilePicker from "../../molecules/filePicker/filePicker";
import {ImageEditorObservable} from "../../../stores/observables/imageEditorObservable";

export interface IImageSelectorProps {
  value: ImageObservable | ImageEditorObservable;
  onImageSelect: (file: File) => void;
  imageLoading: boolean;
  label: string;
  validationMessage?: string;
  disabled?: boolean;
  isRequired?: boolean;
}

const ImageSelector: React.FC<IImageSelectorProps> = ({
  onImageSelect,
  imageLoading,
  disabled = false,
  validationMessage,
  value,
  label,
  isRequired = true
}) => {
  const isSrcEmpty = value.file === null;
  return (
    <>
      <EditField
        label={label}
        validationMessage={validationMessage}
        showValidationMessage={!value.isValid}
        isRequired={value.validate != null && isRequired}
      >
        <Container fluid>
          {isSrcEmpty && (
            <Row>
              <FilePicker
                isValid={value.isValid}
                isDisabled={imageLoading || disabled}
                acceptedFileTypes={".jpg, .jpeg, .png"}
                onFilePicked={onImageSelect}
              />
            </Row>
          )}
        </Container>
        <ImagePreview value={value} disabled={disabled} />
      </EditField>
    </>
  );
};

export default observer(ImageSelector);
